var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9340_15981)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_9340_15981)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9922 14.2041C24.222 13.9743 24.5945 13.9743 24.8242 14.2041L26.9441 16.3239C27.1738 16.5536 27.1738 16.9262 26.9441 17.1559L22.1461 21.9539C21.9163 22.1837 21.5438 22.1837 21.314 21.9539L19.1942 19.8341C18.9645 19.6043 18.9645 19.2318 19.1942 19.002L23.9922 14.2041ZM25.8849 13.1434C25.0694 12.3279 23.7471 12.3279 22.9316 13.1434L18.1336 17.9414C17.318 18.7569 17.318 20.0792 18.1336 20.8947L20.2534 23.0146C21.0689 23.8301 22.3912 23.8301 23.2067 23.0146L25.0825 21.1388L30.5778 26.634C30.8707 26.9269 31.3455 26.9269 31.6384 26.634C31.9313 26.3411 31.9313 25.8662 31.6384 25.5733L26.1432 20.0781L28.0047 18.2166C28.8203 17.401 28.8203 16.0788 28.0047 15.2632L25.8849 13.1434ZM15.5653 25.7681C14.5988 25.7681 13.8153 26.5516 13.8153 27.5181V29.9677H12.8855C12.4713 29.9677 12.1355 30.3034 12.1355 30.7177C12.1355 31.1319 12.4713 31.4677 12.8855 31.4677H14.5653H24.9789H26.6587C27.073 31.4677 27.4087 31.1319 27.4087 30.7177C27.4087 30.3034 27.073 29.9677 26.6587 29.9677H25.7289V27.5181C25.7289 26.5516 24.9454 25.7681 23.9789 25.7681H15.5653ZM24.2289 29.9677H15.3153V27.5181C15.3153 27.38 15.4273 27.2681 15.5653 27.2681H23.9789C24.117 27.2681 24.2289 27.38 24.2289 27.5181V29.9677Z",
    fill: "#1B202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9340_15981",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9340_15981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRequests);
export default __webpack_public_path__ + "static/media/data-requests.2600ab5df74a8c9910488f7460fb14fe.svg";
export { ForwardRef as ReactComponent };